import { render, staticRenderFns } from "./ldz.vue?vue&type=template&id=024dda47&scoped=true&"
import script from "./ldz.vue?vue&type=script&lang=js&"
export * from "./ldz.vue?vue&type=script&lang=js&"
import style0 from "./ldz.vue?vue&type=style&index=0&id=024dda47&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024dda47",
  null
  
)

export default component.exports